// extracted by mini-css-extract-plugin
export default {"towerAbout":"ShopTower_towerAbout__7Anmg","image":"ShopTower_image__fln7W","text":"ShopTower_text__PUVIe"};